import { h, Fragment } from 'preact';

export const Loader = ({ background = '#f3f3f3', foreground = '#3498db', size = 64 }) => (
    <Fragment>
        <style>
            {
                `
                    .__loader__ {
                      border: ${size/8}px solid ${background};
                      border-radius: 50%;
                      border-top: ${size/8}px solid ${foreground};
                      width: ${size}px;
                      height: ${size}px;
                      -webkit-animation: spin 2s linear infinite; /* Safari */
                      animation: spin 2s linear infinite;
                    }

                    /* Safari */
                    @-webkit-keyframes spin {
                      0% { -webkit-transform: rotate(0deg); }
                      100% { -webkit-transform: rotate(360deg); }
                    }

                    @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                    }
                `
            }
        </style>
        <div className="__loader__" />
    </Fragment>
);